import { jsxs as _jsxs } from "react/jsx-runtime";
import Typography from "@mui/material/Typography";
import { useCsAttribute } from "@plansoft-configuration-renderer/framework";
import { shouldShowIndexInSubstructure } from "../../Configuration/shared/shouldShowIndexInSubstructure";
import { useSubstructureLayout } from "./useSubstructureLayout";
export function SubstructureLabel(props) {
    var _a;
    const { substructure } = props;
    const attribute = useCsAttribute();
    const { showIndexInLabel = shouldShowIndexInSubstructure(attribute) } = useSubstructureLayout();
    const label = (_a = substructure.name) !== null && _a !== void 0 ? _a : substructure.id;
    const instanceNumber = showIndexInLabel ? substructure.index + 1 : null;
    return (_jsxs(Typography, { children: [label, " ", instanceNumber] }));
}
//# sourceMappingURL=SubstructureLabel.js.map